export enum AnalyticsDimension {
    Country = 'country',
    Region = 'region',
    City = 'city',
    Browser = 'browser',
    OperatingSystem = 'operatingSystem',
    Device = 'device',
    ScreenSize = 'screenSize',
    ReferrerSource = 'referrerSource',
    Channel = 'channel',
    UtmSource = 'utmSource',
    UtmMedium = 'utmMedium',
    UtmCampaign = 'utmCampaign',
    UtmContent = 'utmContent',
    UtmTerm = 'utmTerm',
    Page = 'page',
    Hostname = 'hostname',
    EntryPage = 'entryPage',
    ExitPage = 'exitPage',
    TrafficType = 'trafficType',
    BotName = 'botName',
    BotCategory = 'botCategory',
    EventName = 'eventName',
}
